/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Canvas_Domain_Copy_AriaInputs */



/**
* | output |
* | --- |
* | "Copy {field}" |
*
* @param {Canvas_Domain_Copy_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_copy_aria = /** @type {((inputs: Canvas_Domain_Copy_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Copy_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.field} kopieren`)
	return /** @type {LocalizedString} */ (`Copy ${i?.field}`)
});